import { render, staticRenderFns } from "./branch-company-table.vue?vue&type=template&id=15742570&"
import script from "./branch-company-table.vue?vue&type=script&lang=js&"
export * from "./branch-company-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports